import BaseService from '@src/services/BaseService'

class SchedulesService extends BaseService {
    constructor() {
        super('schedules')
    }

    fetchVuetable(apiUrl, { params } = { params: {} }) {
        return super.fetchVuetable(apiUrl, { params })
    }

    create(params) {
        const payload = this.normalizePayload(params)
        return super.create(payload)
    }

    update(id, params) {
        const payload = this.normalizePayload(params)
        return super.update(id, payload)
    }

    delete(id) {
        return this.axios.post(`${this.getUrl()}/${id}/delete`)
    }

    /**
     * Preview impact for the given schedule payload (date, filter_type, filter_values).
     * @param {Object} params - Must include date, filter_type, filter_values
     * @returns {Promise<{ data: { affected_users_count: number, affected_items_count: number } }>}
     */
    previewImpact(params) {
        const payload = this.normalizePayload(params)
        return this.axios.post(`${this.getUrl()}/preview-impact`, payload)
    }

    /**
     * Normalize payload for create/update: ensure date is Y-m-d and filter_values are IDs only.
     * @param {Object} params - Raw modal payload (may have Date object and filter_values as objects)
     * @returns {Object} - Payload suitable for API
     */
    normalizePayload(params) {
        const payload = { ...params }
        if (payload.date) {
            const d = payload.date
            if (d instanceof Date && !Number.isNaN(d.getTime())) {
                payload.date = this.formatDateAsLocalYmd(d)
            } else if (typeof d === 'string' && d.length >= 10) {
                payload.date = d.slice(0, 10)
            }
        }
        if (Array.isArray(payload.filter_values)) {
            payload.filter_values = payload.filter_values.map((v) =>
                typeof v === 'object' && v !== null && 'id' in v ? v.id : v
            )
        }
        return payload
    }

    formatDateAsLocalYmd(date) {
        const year = String(date.getFullYear())
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
    }
}

export default new SchedulesService()
